import { createFileRoute } from '@tanstack/react-router'
import { useDeferredValue } from 'react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Board } from './-components/shared/board'
import { BoardPending } from './-components/shared/board-pending'
import { trpc } from '@/main'
import { useRootSearch } from '@/hooks/use-root-search'
import { PanelEmptyState } from './-components/shared/panel-empty-state'
import { UsersIcon } from 'lucide-react'
import { useLingui } from '@lingui/react/macro'

export const Route = createFileRoute('/_app/orgs/$orgId/groups/$groupId/board')({
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) => {
    context.queryClient.prefetchQuery(
      trpc.orgs.getOrgGroupProfile.queryOptions({
        orgId: params.orgId,
        groupId: params.groupId,
        orgType: deps.orgType,
      }),
    )
  },
  component: RouteComponent,
  pendingComponent: BoardPending,
})

function RouteComponent() {
  const { t } = useLingui()
  const { orgId, groupId } = Route.useParams()
  const { second } = useRootSearch()

  if (!second?.id) {
    return (
      <PanelEmptyState
        icon={<UsersIcon className="text-muted-foreground size-5" />}
        title={t`Select a user`}
        description={t`Select a user from the list to view their profile.`}
      />
    )
  }

  return <BoardLoaded orgId={orgId} groupId={groupId} />
}

function BoardLoaded(props: { orgId: string; groupId: string }) {
  const { orgType } = useRootSearch()
  const deferredOrgType = useDeferredValue(orgType)
  const { data: orgGroupProfile } = useSuspenseQuery(
    trpc.orgs.getOrgGroupProfile.queryOptions({ orgId: props.orgId, groupId: props.groupId, orgType: deferredOrgType }),
  )

  return <Board name={orgGroupProfile?.name} profiles={orgGroupProfile?.profiles ?? []} />
}
